var _effectorFileName = "/src/page-content/agreement/model.ts";
import { pagesPath } from '@/shared/config/$path';
import { declarePage } from '@/shared/lib/effector/page';
export const agreementPage = declarePage({
  pageType: pagesPath.$url().pathname
});